import React, {useMemo} from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ToggleButton } from '../atoms';

import { ListingProductDetails } from '../../components/listing/ListingProductDetails';

export function SortableProductItem({
  id,
  listing,
  settings,
  changeNote,
  toggleListingHideUrl,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const content = useMemo(() => {
    // The row cannot be built without a listing. Checked HERE rather than above
    // the hook, so the hook itself runs on every render (see the guard below).
    if (!listing) return null;

    return (
      <div className="sortable-product-item listing-details-row p-2 p-lg-4 ps-lg-5 row">
        <div className="lb-mobile">
          <ToggleButton label="HIDE URL" checked={!!settings[id]?.hideUrl} onChange={() => toggleListingHideUrl(id)} />
        </div>

        <div className="col-12 col-lg-6">
          <ListingProductDetails listing={listing} product={listing.product} />
        </div>

        <div className="col-12 col-lg-6 lookbook-settings">
          <div className="lb-desktop">
            <ToggleButton label="HIDE URL" checked={!!settings[id]?.hideUrl} onChange={() => toggleListingHideUrl(id)} />
          </div>

          <div className="lookbook-note">
            <textarea
              key={`note-${id}`}
              rows={3}
              value={settings[id]?.note}
              onChange={(e) => changeNote(id, e.target.value)}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
              onPointerDown={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
            />
          </div>
        </div>
      </div>
    )
  }, [listing, settings[id]]);

  if (!listing) {
    return null;
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {content}
    </div>
  );
}
